import { useApiDown } from '../utils/axios'

export default useApiDown
export { useApiDown }
